module.exports = __webpack_public_path__ + "img/twitter.060fbc44.svg";